import { definePreset } from "@primeuix/themes";
import Aura from "@primeuix/themes/aura";
import {
    primitiveColorTokens,
    primitiveFontTokens,
    primitiveLayoutTokens,
    semanticTokens,
} from "src/assets/layout/styles/tokens";
import { accordion } from "src/assets/layout/styles/components/accordion";
import { avatar } from "src/assets/layout/styles/components/avatar";
import { button } from "src/assets/layout/styles/components/button";
import { checkbox } from "src/assets/layout/styles/components/checkbox";
import { dialog } from "src/assets/layout/styles/components/dialog";
import { menu } from "src/assets/layout/styles/components/menu";
import { progressSpinner } from "src/assets/layout/styles/components/progress-spinner";
import { select } from "src/assets/layout/styles/components/select";
import { tabs } from "src/assets/layout/styles/components/tab";
import { datatable } from "src/assets/layout/styles/components/datatable";
import { card } from "src/assets/layout/styles/components/card";
import { inputtext } from "src/assets/layout/styles/components/inputtext";
import { iconfield } from "src/assets/layout/styles/components/iconfield";
import { paginator } from "src/assets/layout/styles/components/paginator";
import { panel, panelPt } from "src/assets/layout/styles/components/panel";
import { panelmenu } from "src/assets/layout/styles/components/panel-menu";

export const AzaraPreset = definePreset(Aura, {
    primitive: { ...primitiveColorTokens, ...primitiveFontTokens, ...primitiveLayoutTokens },
    semantic: semanticTokens,
    components: {
        accordion,
        avatar,
        button,
        card,
        checkbox,
        datatable,
        dialog,
        iconfield,
        inputtext,
        menu,
        paginator,
        panel,
        panelmenu,
        progressSpinner,
        select,
        tabs,
    },
});

export const GlobalPassThroughs = {
    panel: panelPt,
};
